module.exports = __webpack_public_path__ + "static/img/reviews_user6.9560ea6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/reviews_user6.png
// module id = 332
// module chunks = 1